$(function() {
    let variants = window.variants;
    let videoMuted = true;
    let videoPlayers = {};
    function getPlayerForIframe( iframe ) {
        if ( ! iframe ) {
            return null;
        }
        let key = iframe.getAttribute( 'data-player-id' );
        if ( ! key ) {
            key = 'player_' + Object.keys( videoPlayers ).length;
            iframe.setAttribute( 'data-player-id', key );
        }
        if ( videoPlayers[ key ] ) {
            return videoPlayers[ key ];
        }
        const p = new playerjs.Player( iframe );
        videoPlayers[ key ] = p;
        return p;
    }
    function pauseAllVideoSlides() {
        $( '.product .banner .slider.one .slides .slide.video iframe' ).each(function() {
            const p = getPlayerForIframe( this );
            if ( ! p ) {
                return;
            }
            try {
                if ( p.pause ) {
                    p.pause();
                }
                if ( p.mute ) {
                    p.mute();
                }
                if ( p.setVolume ) {
                    p.setVolume( 0 );
                }
            } catch ( e ) {}
        });
    }
    function playVideoForSlide( $slide ) {
        if ( ! $slide || ! $slide.length ) {
            return;
        }
        if ( ! $slide.hasClass( 'video' ) ) {
            return;
        }
        const iframe = $slide.find( 'iframe' )[ 0 ];
        if ( ! iframe ) {
            return;
        }
        const p = getPlayerForIframe( iframe );
        if ( ! p ) {
            return;
        }
        function apply() {
            try {
                if ( videoMuted ) {
                    if ( p.mute ) {
                        p.mute();
                    }
                    if ( p.setVolume ) {
                        p.setVolume( 0 );
                    }
                } else {
                    if ( p.unmute ) {
                        p.unmute();
                    }
                    if ( p.setVolume ) {
                        p.setVolume( 100 );
                    }
                }
                if ( p.play ) {
                    p.play();
                }
            } catch ( e ) {}
        }
        try {
            p.on( 'ready', apply );
        } catch ( e ) {}
        apply();
    }
    Utils.showNavigation();
    $(window).on( 'scroll', function( event ) {
        Utils.showNavigation();
    });
    $( '.tone.color' ).each(function() {
        $( '.terms .term', this ).each(function() {
            const $parent = $( this ).parent();
            const $last = $parent.children( '.term:not([data-id])' );
            let $terms = $parent.children( '.term[data-id]' );
            $terms.sort(function( a, b ) {
                var aValue = parseInt( $( a ).data( 'id' ) );
                var bValue = parseInt( $( b ).data( 'id' ) );
                return aValue - bValue;
            });
            $parent.html( $terms ).append( $last );
        });
    });
    const queryString = window.location.search;
    const urlParams = new URLSearchParams( queryString );
    setTimeout(() => {
        if ( urlParams.get( 'variant' ) ) {
            $( 'form[action*="/cart/add"]' ).find( 'select[name="id"]' ).val( urlParams.get( 'variant' ) );
            buildBuyNowButton( urlParams.get( 'variant' ) );
        }
    }, 100);
    var swiperProductOne = new Swiper( '.product .banner .slider.one', {
        containerModifierClass: 'slider-',
        slideActiveClass: 'active',
        slideBlankClass: 'blank',
        slideClass: 'slide',
        slideNextClass: 'next',
        slidePrevClass: 'previous',
        slideVisibleClass: 'visible',
        wrapperClass: 'slides',
        autoHeight: true,
        slidesPerGroup: 1,
        spaceBetween: 35,
        watchOverflow: true,
        loop: $( '.product .banner .slider .slides .slide' ).length != 1,
        navigation: {
            disabledClass: 'disabled',
            nextEl: '.product .banner .slider .button.next',
            prevEl: '.product .banner .slider .button.previous'
        },
        pagination: {
            bulletClass: 'icon',
            bulletActiveClass: 'active',
            el: '.product .overview .pagination'
        },
        zoom: {
            containerClass: 'content',
            maxRatio: 1.75,
            minRatio: 1,
            zoomedSlideClass: 'magnify'
        },
        breakpoints: {
            0: {
                speed: 400
            },
            1025: {
                speed: 800
            }
        }
    });
    var swiperProductThree = new Swiper( '.related:not(.hidden) .slider', {
        containerModifierClass: 'slide-',
        noSwipingClass: 'alt',
        slideActiveClass: 'active',
        slideBlankClass: 'blank',
        slideClass: 'slide',
        slideNextClass: 'next',
        slidePrevClass: 'previous',
        slideVisibleClass: 'visible',
        wrapperClass: 'slides',
        speed: 750,
        navigation: {
            disabledClass: 'disabled',
            nextEl: '.related .slider .buttons .next',
            prevEl: '.related .slider .buttons .previous'
        },
        breakpoints: {
            300: {
                spaceBetween: 12,
                slidesPerView: 2
            },
            600: {
                spaceBetween: 17,
                slidesPerView: 3
            },
            900: {
                spaceBetween: 22,
                slidesPerView: 4
            }
        }
    });
    if ( ! window.selectedPaint ) {
        $( '.product .banner' ).removeClass( 'hidden' );
    }
    if ( $( '.product .overview .content .blocks.three .attributes .attribute' ).length == 0 ) {
        $( '.product .overview .content .blocks.three .attributes' ).addClass( 'alt' );
    }
    $( document ).on( 'click', '.product-form .attribute.size .term', function() {
        const redirect = $( 'a', this ).attr( 'href' );
        if ( redirect ) {
            location.href = redirect;
            return;
        }
        if ( $( '.product-form .attribute.weight' ).length ) {
            let colour = $( '.product-form .attribute.color .text.product-form__selected-value' ).text();
            let size = $( this ).attr( 'value' );
            let $weight = $( '.product-form .attribute.weight .term:not(.hidden).selected' );
            if ( ! $weight ) {
                $weight = $( '.product-form .attribute.weight .term:visible' ).first();
            }
            let weight = $weight.attr( 'value' );
            let index = variants.findIndex( item => item.options.includes( colour ) && item.options.includes( size ) && item.options.includes( weight ) );
            let other_variants = variants.filter( item => item.options.includes( colour ) && item.options.includes( size ) );
            let variant = index != -1 ? variants[ index ] : other_variants[ 0 ];
            updateBanner( variant );
            $( '.product-form .attribute.weight .term' ).addClass( 'hidden' );
            other_variants.forEach( item => {
                $( '.product-form .attribute.weight .term[data-variant_id="' + item.id + '"]' ).removeClass( 'hidden' );
            });
            $( '.product-form .attribute.weight .term' ).removeClass( 'selected' );
            $( '.product-form .attribute.weight .term[data-variant_id="' + variant.id + '"]' ).addClass( 'selected' );
            $( '.product-form .attribute.size .text.product-form__selected-value' ).text( size );
            $( this ).closest( 'product-form' ).find( 'input[name="product-id"]' ).val( variant.id );
        } else {
            if ( $( this ).attr( 'value' ).includes( 'Shaped' ) ) {
                $( '.product .overview .content .form .blocks.three .block .fields .attributes .attribute.size .content .select.alt .text' ).text( $( this ).attr( 'value' ) );
            }
            let variant_id = $( this ).data( 'variant_id' );
            let variant = variants.filter( item => item.id == variant_id )[ 0 ];
            if ( ! variant ) {
                let indexAlt = $( this ).data( 'variant-pos' );
                variant = variants[ indexAlt ];
            }
            variant = variant ? variant : variants[ 0 ];
            updateBanner( variant );
            $( '.size.paint .terms .term' ).removeClass( 'selected' );
            $( this ).addClass( 'selected' );
        }
    });
    $( document ).on( 'click', '.product .overview .content form .fields .attributes .attribute.size .content .select.alt', function() {
        let $modal = $( '.product-form .attribute.size .modal' );
        if ( ! $modal.length ) {
            return false;
        }
        let colour = $( '.product-form .attribute.color .text.product-form__selected-value' ).text();
        let $weight = $( '.product-form .attribute.weight .term:not(.hidden).selected' );
        if ( ! $weight ) {
            $weight = $( '.product-form .attribute.weight .term:visible' ).first();
        }
        let weight = $weight.attr( 'value' );
        $modal.find( '.terms .term' ).each(function() {
            let size = $( this ).attr( 'value' );
            let index = variants.findIndex( item => item.options.includes( colour ) && item.options.includes( weight ) && item.options.includes( size ) );
            if ( index >= 0 ) {
                let price = window.theme.currencySymbol + ( variants[ index ].price / 100 ).toString();
                if ( ! $( '.price', this ).length ) {
                    $( '.text', this ).after( `<div class="price">${price}</div>` );
                } else {
                    $( this ).find( '.price' ).text( price );
                }
            }
        });
    });
    $( document ).on( 'click', '.product .overview .content form .fields .attributes .attribute.colour.grout .content .select.alt', function() {
        let $modal = $( '.product-form .attribute.colour.grout .modal' );
        if ( ! $modal.length ) {
            return false;
        }
        let colour = $( '.product-form .attribute.colour.grout .text.product-form__selected-value' ).text();
        let $weight = $( '.product-form .attribute.weight .term:not(.hidden).selected' );
        if ( ! $weight ) {
            $weight = $( '.product-form .attribute.weight .term:visible' ).first();
        }
        let weight = $weight.attr( 'value' );
        $modal.find( '.terms .term' ).each(function() {
            let size = $( this ).attr( 'value' );
            let index = variants.findIndex( item => item.options.includes( colour ) && item.options.includes( weight ) && item.options.includes( size ) );
            if ( index >= 0 ) {
                let price = window.theme.currencySymbol + ( variants[ index ].price / 100 ).toString();
                if ( ! $( '.price', this ).length ) {
                    $( '.text', this ).after( `<div class="price">${price}</div>` );
                } else {
                    $( this ).find( '.price' ).text( price );
                }
            }
        });
    });
    $( document ).on( 'click', '.product-form .attribute.weight .term', function() {
        if ( ! $( 'a', this ).length ) {
            $( '.product-form .attribute.weight .term' ).removeClass( 'selected' );
            $( this ).addClass( 'selected' );
            let variant_id = $( this ).data( 'variant_id' );
            let variant = variants.filter( variantItem => variantItem.id == variant_id )[ 0 ];
            updateBanner( variant );
            let weight = variant.option3;
            if ( ! weight ) {
                weight = variant.option2;
            }
            setTimeout(() => {
                $( '.product .weight .select.alt .text' ).text( weight );
            }, 1);
        }
    });
    if ( window.isShaped ) {
        $( '.attribute.color .modal .tone .term' ).click(function( e ) {
            let variant = variants[ $( this ).data( 'variant-pos' ) ];
            if ( variant.available ) {
                $( '#add-to-bag' ).removeAttr( 'disabled' ).removeClass( 'disabled' ).find( '.text' ).text( 'Add To Bag' );
            } else {
                $( '#add-to-bag' ).attr( 'disabled', true ).addClass( 'disabled' ).find( '.text' ).text( 'Sold Out' );
            }
        });
    }
    if ( $( '.product-form .attribute.weight .term' ).length ) {
        setDefaultWeights();
    } else if ( window.selectedVariant ) {
        updateBanner( window.selectedVariant );
        $( '.product-form .attribute.size .term[data-variant_id="' + window.selectedVariant.id + '"]' ).addClass( 'selected' );
    }
    Product.getBundles();
    $( document ).on( 'click', '.product .banner .content .slider .slides .slide .overlay', function() {
        $( 'meta[name="theme-color"]' ).attr( 'content', '#FEFEFE' );
        $( 'body' ).addClass( 'overflow' );
        $( '.product .banner' ).addClass( 'active' );
    });
    $( '.product .banner .content .close' ).click(function() {
        $( 'meta[name="theme-color"]' ).attr( 'content', '#101820' );
        $( 'body' ).removeClass( 'overflow' );
        $( '.product .banner' ).removeClass( 'active' );
    });
    $( '.product .banner .content .slider .button.zoom .button.circle.alt.zoom-in' ).click(function() {
        swiperProductOne.zoom.in();
    });
    $( '.product .banner .content .slider .button.zoom .button.circle.alt.zoom-out' ).click(function() {
        swiperProductOne.zoom.out();
    });
    swiperProductOne.on( 'slideChangeTransitionEnd', function() {
        const _this = $( this );
        const idx = _this[ 0 ].activeIndex;
        const $slide = $( _this[ 0 ].slides[ idx ] );
        pauseAllVideoSlides();
        if ( $slide.hasClass( 'video' ) ) {
            $( '.product .banner .content .slider .button.video' ).removeClass( 'one' );
            $( '.product .banner .content .slider .button.video' ).addClass( 'two' );
            let variant_id = $slide.data( 'variant_id' );
            let variant = variants.find( item => item.id == variant_id );
            let videos_key = $( window ).width() < 600 ? 'videos_mobile' : 'videos';
            videos_key = ( videos_key in variant ) && variant[ videos_key ].length > 0 ? videos_key : 'videos';
            if ( variant[ videos_key ].length > 1 ) {
                const rawIndex = $slide.data( 'video_index' );
                const videoIndex = isNaN( parseInt( rawIndex, 10 ) ) ? 0 : parseInt( rawIndex, 10 );
                if ( $( document ).find( '.product .banner .slider .button.video .button.alt.number' ).length == 0 ) {
                    $( '.product .banner .slider .button.video' ).append(
                        `<div class="button small alt number">
                            <a>
                                <div class="icon">
                                    <i class="icons8 icons8-circled-play"></i>
                                </div>
                                <div class="text">Video ${videoIndex + 1} of ${variant[ videos_key ].length}</div>
                                <div class="background"></div>
                            </a>
                        </div>`
                    );
                } else {
                    $( document ).find( '.product .banner .slider .button.video .button.alt.number .text' ).text( `Video ${videoIndex + 1} of ${variant[ videos_key ].length}` );
                }
            }
            $( '.product .banner .content .slider .button.video' ).removeClass( 'unmute' );
            $( '.product .banner .content .slider .button.video' ).addClass( 'mute' );
            videoMuted = true;
            playVideoForSlide( $slide );
        } else {
            $( '.product .banner .content .slider .button.video' ).removeClass( 'two' );
            $( '.product .banner .content .slider .button.video' ).addClass( 'one' );
            $( document ).find( '.product .banner .slider .button.video .button.alt.number' ).remove();
        }
    });
    $( document ).on( 'click', '.product .banner .content .slider .button.video .button.small.alt.number', function() {
        swiperProductOne.slideNext();
    });
    $( '.product .banner .content .slider .button.video .button.small.alt.view' ).click(function( e ) {
        swiperProductOne.slideTo( swiperProductOne.slides.findIndex( item => $( item ).hasClass( 'video' ) && ! $( item ).hasClass( 'last' ) ), 0 );
    });
    $( document ).on(
        'click',
        '.product .banner .content .slider .button.video [data-vimeo="unmute"], .product .banner .content .slider .button.video .button.small.alt.unmute',
        function( e ) {
            e.preventDefault();
            videoMuted = false;
            $( '.product .banner .content .slider .button.video' ).removeClass( 'mute' );
            $( '.product .banner .content .slider .button.video' ).addClass( 'unmute' );
            pauseAllVideoSlides();
            const idx = swiperProductOne.activeIndex;
            const $slide = $( swiperProductOne.slides[ idx ] );
            playVideoForSlide( $slide );
        }
    );
    $( document ).on(
        'click',
        '.product .banner .content .slider .button.video [data-vimeo="mute"], .product .banner .content .slider .button.video .button.small.alt.mute',
        function( e ) {
            e.preventDefault();
            videoMuted = true;
            $( '.product .banner .content .slider .button.video' ).removeClass( 'unmute' );
            $( '.product .banner .content .slider .button.video' ).addClass( 'mute' );
            pauseAllVideoSlides();
            const idx = swiperProductOne.activeIndex;
            const $slide = $( swiperProductOne.slides[ idx ] );
            playVideoForSlide( $slide );
        }
    );
    function setDefaultWeights() {
        let colour = $( '.product-form .attribute.color .text.product-form__selected-value' ).text();
        let size = $( '.product-form .attribute.size:not(.grout.colour) .term.selected' ).attr( 'value' );
        if ( ! size ) {
            $( '.product-form .attribute.size:not(.grout.colour) .term:not(.disabled)' ).first().addClass( 'selected' );
            size = $( '.product-form .attribute.size:not(.grout.colour) .term:not(.disabled)' ).first().attr( 'value' );
            $( '.product .overview .content .form .blocks.three .block .fields .attributes .attribute.size:not(.grout.colour) .content .select.alt .text' ).text( size );
        }
        let variant = null;
        let other_variants = [];
        if ( urlParams.get( 'variant' ) ) {
            let variant_id = urlParams.get( 'variant' );
            let index = variants.findIndex( item => item.id == variant_id );
            if ( index != -1 ) {
                variant = variants[ index ];
                if ( $( '.product-form .attribute.size:not(.grout.colour)' ).length ) {
                    size = variant.option2;
                    other_variants = variants.filter( item => item.options.includes( colour ) && item.options.includes( size ) );
                } else {
                    other_variants = variants.filter( item => item.options.includes( colour ) );
                }
                other_variants.forEach( item => {
                    $( '.product-form .attribute.weight .term[data-variant_id="' + item.id + '"]' ).removeClass( 'hidden' );
                });
            }
        } else {
            if ( size ) {
                other_variants = variants.filter( item => item.options.includes( colour ) && item.options.includes( size ) );
            } else {
                other_variants = variants.filter( item => item.options.includes( colour ) );
            }
            if ( other_variants.length == 0 ) {
                other_variants = variants;
            }
            other_variants.forEach( item => {
                $( '.product-form .attribute.weight .term[data-variant_id="' + item.id + '"]' ).removeClass( 'hidden' );
            });
            variant = other_variants[ 0 ];
            variant = variant ? variant : variants[ 0 ];
        }
        updateBanner( variant );
        if ( window.productOptions ) {
            let indexOpt = window.productOptions.findIndex( item => [ 'weight', 'volume' ].includes( item.toLowerCase() ) );
            $( '.product .weight .select.alt .text' ).text( variant.options[ indexOpt ] );
        }
        $( '.product-form .attribute.weight .term[data-variant_id="' + variant.id + '"]' ).addClass( 'selected' );
        window.selectedVariant = variant;
    }
    function updateBanner( variant ) {
        videoPlayers = {};
        videoMuted = true;
        pauseAllVideoSlides();
        if ( variant.available ) {
            $( '#add-to-bag' ).removeAttr( 'disabled' ).removeClass( 'disabled' ).find( '.text' ).text( 'Add To Bag' );
        } else {
            $( '#add-to-bag' ).attr( 'disabled', true ).addClass( 'disabled' ).find( '.text' ).text( 'Sold Out' );
        }
        let images = variant.images;
        if ( swiperProductOne ) {
            swiperProductOne.removeAllSlides();
        }
        const numbersToWords = Utils.numberToWords();
        let $slides = [];
        images.forEach(( image, i ) => {
            let image_theme = 'default';
            if ( image.includes( 'DB_' ) || image.includes( '-DB.' ) ) {
                image_theme = 'dark';
            } else if ( image.includes( '-LB_' ) || image.includes( '-LB.' ) ) {
                image_theme = 'light';
            }
            const $slide = `<div class="slide ${numbersToWords[ i ]}">
                  <div class="overlay"></div>
                  <div class="content">
                      <div class="image swiper-zoom-target active" data-variant-pos="${i}" role="img" data-image="${( image.includes( 'T2A' ) ? 'background' : 'default' )}" style="background-image: url('${image}')" data-theme="${image_theme}"></div>
                  </div>
              </div>`;
            $slides.push( $slide );
        });
        if ( ( 'videos' in variant ) || ( 'videos_mobile' in variant ) ) {
            $( '.product .banner .content .slider .button.video' ).removeClass( 'hidden' );
            let videos_key = $( window ).width() < 600 ? 'videos_mobile' : 'videos';
            videos_key = ( videos_key in variant ) && variant[ videos_key ].length > 0 ? videos_key : 'videos';
            variant[ videos_key ].forEach(( video, i ) => {
                try {
                    const u = new URL( video, window.location.href );
                    if ( ! u.searchParams.has( 'autoplay' ) ) {
                        u.searchParams.set( 'autoplay', 'true' );
                    }
                    if ( ! u.searchParams.has( 'muted' ) ) {
                        u.searchParams.set( 'muted', 'true' );
                    }
                    if ( ! u.searchParams.has( 'playsinline' ) ) {
                        u.searchParams.set( 'playsinline', 'true' );
                    }
                    video = u.toString();
                } catch ( e ) {
                    video += ( video.indexOf( '?' ) === -1 ? '?' : '&' ) + 'autoplay=true&muted=true&playsinline=true';
                }
                $slides.push(
                    `<div class="slide video${( i == variant[ videos_key ].length - 1 ? ' last' : '' )}${( videos_key == 'videos_mobile' ? ' alt' : '' )}" data-variant_id="${variant.id}" data-video_index="${i}">
                        <div class="overlay"></div>
                        <div class="content">
                            <div class="video">
                                <iframe
                                    src="${video}"
                                    width="100%"
                                    height="500px"
                                    frameborder="0"
                                    allow="autoplay; fullscreen; picture-in-picture"
                                    allowfullscreen
                                    playsinline
                                ></iframe>
                            </div>
                        </div>
                    </div>`
                );
            });
            $( '.product .banner .content .slider .button.video .button.small.alt.view .text' ).text( 'Video' + ( variant[ videos_key ].length > 1 ? 's' : '' ) );
        }
        if ( swiperProductOne ) {
            swiperProductOne.appendSlide( $slides );
            swiperProductOne.slideTo( 1, 0 );
            setTimeout(() => {
                const idx = swiperProductOne.activeIndex;
                const $active = $( swiperProductOne.slides[ idx ] );
                pauseAllVideoSlides();
                if ( $active.hasClass( 'video' ) ) {
                    $( '.product .banner .content .slider .button.video' ).removeClass( 'unmute' );
                    $( '.product .banner .content .slider .button.video' ).addClass( 'mute' );
                    videoMuted = true;
                    playVideoForSlide( $active );
                }
            }, 0);
        }
        $( '.product .images .content .sections .section.one .blocks .block .image' ).css( 'background-image', 'url(' + images[ 1 ] + ')' );
        $( '.product .images .content .sections .section.two .blocks .block .image' ).css( 'background-image', 'url(' + images[ 2 ] + ')' );
        setTimeout(() => {
            $( 'form[action*="/cart/add"] select[name="id"]' ).val( variant.id );
            if ( 'videos' in variant ) {
                $( '.product .banner .content .slider .button.video' ).removeClass( 'two' );
                $( '.product .banner .content .slider .button.video' ).addClass( 'one' );
            } else {
                $( '.product .banner .content .slider .button.video' ).removeClass( 'one' );
                $( '.product .banner .content .slider .button.video' ).addClass( 'two' );
                $( '.product .banner .content .slider .button.video' ).addClass( 'hidden' );
            }
            buildBuyNowButton( variant.id );
        }, 100);
    }
    function updatePriceDisplay( product_id = null ) {
        if ( ! product_id ) {
            product_id = ( new URLSearchParams( $( 'form[action*="/cart/add"]' ).serialize() ) ).get( 'id' );
        }
        if ( product_id ) {
            let index = variants.findIndex( item => item.id == product_id );
            if ( index >= 0 ) {
                let variant = variants[ index ];
                let price = window.theme.currencySymbol + ( variant.price / 100 ).toString();
                $( '.product .overview .content .blocks.two .block .price .text' ).text( price );
            }
        }
    }
    function buildBuyNowButton( product_id = null ) {
        let quantity = $( 'input[name="quantity"]' ).val();
        if ( ! product_id ) {
            product_id = ( new URLSearchParams( $( 'form[action*="/cart/add"]' ).serialize() ) ).get( 'id' );
        }
        if ( ! $( '#add-to-bag' ).hasClass( 'disabled' ) ) {
            $( '.buy' ).removeClass( 'hidden' );
            $( '.buy a' ).attr( 'href', window.theme.shopUrl + '/cart/' + product_id + ':' + quantity );
        } else {
            $( '.buy' ).addClass( 'hidden' );
        }
    }
    $( '.banner .slide.one .content' ).find( '[data-variant-pos="' + $( '.size .modal .selected' ).data( 'variantPos' ) + '"]' ).addClass( 'active' );
    $( '.banner .slide.two .content' ).find( '[data-variant-pos="' + $( '.size .modal .selected' ).data( 'variantPos' ) + '"]' ).addClass( 'active' );
    if ( $( '.attribute .modal .product-form__single-selector.selected' ).length == 0 ) {
        $( '.banner .slide.last .content .video' ).find( '[data-variant-pos="0"]' ).attr( 'src', $( '.banner .slide.last .content .video' ).find( '[data-variant-pos="0"]' ).data( 'videoSrc' ) );
        $( '.banner .slide.last .content .video' ).find( '[data-variant-pos="0"]' ).addClass( 'active' );
    } else {
        let variantPosInit = $( '.attribute .modal .product-form__single-selector.selected' ).data( 'variantPos' );
        variantPosInit = ! variantPosInit ? 0 : variantPosInit;
        $( '.banner .slide.last .content .video' ).find( '[data-variant-pos="' + variantPosInit + '"]' ).attr( 'src', $( '.banner .slide.last .content .video' ).find( '[data-variant-pos="' + variantPosInit + '"]' ).data( 'videoSrc' ) );
        $( '.banner .slide.last .content .video' ).find( '[data-variant-pos="' + variantPosInit + '"]' ).addClass( 'active' );
    }
    $( '.attribute .product-form__single-selector' ).click(function( e ) {
        $( '.product .overview .content .blocks.three .block .fields .attributes .attribute .content .select.alt.error' ).removeClass( 'error' );
        var variantPos = $( this ).data( 'variantPos' ) || 0;
        history.pushState( null, null, '?variant=' + variants[ variantPos ].id );
        updatePriceDisplay( variants[ variantPos ].id );
        Product.getBundles( variants[ variantPos ] );
        if ( [ 'A5 Peel & Stick Sample' ].includes( $( 'body' ).data( 'product_type' ) ) ) {
            location.reload();
        }
        if ( e.currentTarget.className.includes( 'disabled' ) ) {
            return;
        }
        if ( ( $( this ).closest( '.product-form__option' ).hasClass( 'weight' ) || $( this ).closest( '.product-form__option' ).hasClass( 'size' ) ) && ! $( this ).closest( '.product-form__option' ).hasClass( 'alt' ) ) {
        } else {
            updateBanner( variants[ variantPos ] );
            $( '.banner .slide.last .content .video .active' ).attr( 'src', '' );
            $( '.banner .slide.last .content .video .active' ).removeClass( 'active' );
            $( '.banner .slide.last .content .video' ).find( '[data-variant-pos="' + variantPos + '"]' ).attr( 'src', $( '.banner .slide.last .content .video' ).find( '[data-variant-pos="' + variantPos + '"]' ).data( 'videoSrc' ) );
            $( '.banner .slide.last .content .video' ).find( '[data-variant-pos="' + variantPos + '"]' ).addClass( 'active' );
        }
        if ( $( this ).closest( '.attribute.color.product-form__option' ).length ) {
            let $container = $( this ).closest( '.attribute.color.product-form__option' );
            let text = $( '.title h5', this ).text();
            $container.find( '.select.alt .text' ).text( text );
            $container.find( '.select.alt .swatch' ).css( 'background-image', e.target.style.backgroundImage );
        }
        if ( $( this ).closest( '.attribute' ).hasClass( 'colour grout' ) ) {
            let $containerGrout = $( this ).closest( '.attribute.colour.grout' );
            $containerGrout.find( '.select.alt .swatch' ).css( 'background-color', $( '.swatch', this ).css( 'background-color' ) );
        }
    });
    $( '.product-form .quantity-selector__button' ).on( 'click', function() {
        let quantity = parseInt( $( '.quantity-selector__value' ).val(), 10 );
        quantity = isNaN( quantity ) ? 0 : quantity;
        quantity += $( this ).hasClass( 'plus' ) ? 1 : -1;
        quantity = Math.max( quantity, 1 );
        $( '.quantity-selector__value' ).val( quantity );
        buildBuyNowButton();
    });
    $( '.product .button.buy.alt a' ).click(function( e ) {
        e.preventDefault();
        const $required = $( this ).closest( '.form' ).find( '.select.alt.required' );
        if ( $required.length ) {
            if ( $required.find( '.text' ).text().includes( 'Select ' ) ) {
                $required.addClass( 'error' );
                $( 'html, body' ).animate({ scrollTop: $( this ).closest( '.form' ).offset().top }, 600 );
                return;
            }
        }
        window.location.href = $( this ).attr( 'href' );
    });
    Utils.generateProductReviews( '.related .slider' );
    const swiper_breakpoints = {
        0: {
            spaceBetween: 12,
            slidesPerView: 2
        },
        900: {
            spaceBetween: 12,
            slidesPerView: 1
        },
        1025: {
            spaceBetween: 14,
            slidesPerView: 2
        }
    };
    Utils.generateProductsSlider( '.product .overview .blocks.complementary .slider', swiper_breakpoints );
    saveRecentlyViewedProducts();
    function saveRecentlyViewedProducts() {
        var items = JSON.parse( localStorage.getItem( 'recentlyViewedProducts' ) || '[]' ), currentProductId = window.currentProductId;
        if ( ! items.includes( currentProductId ) ) {
            items.unshift( currentProductId );
        }
        try {
            localStorage.setItem( 'recentlyViewedProducts', JSON.stringify( items.slice( 0, 18 ) ) );
        } catch ( error ) {}
    }
    if ( localStorage.getItem( 'to_show_bag' ) ) {
        $( '.bag.main' ).addClass( 'delay' );
        setTimeout(function() {
            $( '.bag.main' ).addClass( 'active' );
        }, 100);
        localStorage.removeItem( 'to_show_bag' );
    }
    (function mobileAutoplayUnlock() {
        if ( ! /iPhone|iPad|iPod|Android/i.test( navigator.userAgent ) ) {
            return;
        }
        let unlocked = false;
        function unlock() {
            if ( unlocked ) {
                return;
            }
            unlocked = true;
            try {
                pauseAllVideoSlides();
                const idx = swiperProductOne.activeIndex;
                const $slide = $( swiperProductOne.slides[ idx ] );
                playVideoForSlide( $slide );
            } catch ( e ) {}
            window.removeEventListener( 'touchend', unlock, true );
            window.removeEventListener( 'click', unlock, true );
        }
        window.addEventListener( 'touchend', unlock, true );
        window.addEventListener( 'click', unlock, true );
    }());
});
